/** Do not move in the thresholds file, implem imports would break https://gitlab.com/weenat-front/ts-workers/-/blob/main/app/src/schema.ts */
export const thresholdTypes = ['saturation', 'comfort', 'vigilance', 'stress'];
